@import "tailwindcss";

@theme {
  --color-ink: #0f1c2e;
  --color-paper: #fff9f3;
  --color-accent: #ff8a3d;
}

body {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif;
  background:
    radial-gradient(900px 500px at 10% 0%, #ffe1c6 0%, transparent 55%),
    radial-gradient(700px 400px at 90% 10%, #cfe6ff 0%, transparent 55%),
    #fff9f3;
}

.shadow-card {
  box-shadow: 0 10px 30px rgba(7, 18, 35, 0.12);
}

.output-html h2 {
  margin: 0 0 10px;
  font-size: 18px;
  font-family: "Fraunces", serif;
  text-transform: none;
}

.output-html p {
  margin: 0 0 10px;
}

.output-html ul {
  margin: 0 0 12px 18px;
  list-style: disc;
}

.underline-link {
  @apply text-ink underline underline-offset-2;
}
